<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "CustomerDebtor"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/Debtor.vue